import PropTypes from 'prop-types';
import * as React from 'react';
import '../../styles/videoplayer.css';

const propTypes = {
  controls: PropTypes.bool,
  src: PropTypes.string.isRequired,
  poster: PropTypes.string,
};

const defaultProps = {
  controls: true,
  src: '',
  poster: '',
};

function parseSrc(src) {
  if (src === undefined) {
    return undefined
  }
  return src
}

const style = {
  backgroundColor: 'black',
  border: 0,
  height: '100%',
  width: '100%',
}
class VideoPlayer extends React.Component {
  static getDerivedStateFromProps(props, state) {
    if (props.src !== state.currentURL) {
      return {
        draw: false,
        currentURL: props.src
      }
    }
    return null
  }

  constructor(props) {
    super(props)
    this.state = {
      draw: true,
      currentURL: this.props.src
    }
  }

  componentDidUpdate = () => {
    if (!this.state.draw) {
      this.setState({ draw: true })
    }
  }

  /* eslint jsx-a11y/media-has-caption:0 */
  render() {
    const url = parseSrc(this.props.src)
    const poster = parseSrc(this.props.poster)
    if (!this.state.draw) {
      return null
    }
    const server = process.env.NODE_ENV === 'development' ? window.location.origin.replace('3000', '8080') : window.location.origin
    return (
      <iframe
        id="v-iframe"
        src={`${server}/vp?video=${encodeURI(url)}&poster=${poster}`}
        border="0"
        scrolling="no"
        frameBorder="0"
        allowFullScreen="allowFullScreen"
        // mozallowfullscreen="mozallowFullscreen"
        // msallowfullscreen="msallowfullscreen"
        // oallowfullscreen="oallowfullscreen"
        // webkitallowfullscreen="webkitallowfullscreen"
        style={style}
      />
    )
  }
}

VideoPlayer.propTypes = propTypes;
VideoPlayer.defaultProps = defaultProps;

export default VideoPlayer;
